import { Box, Button, Divider, Typography } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import type { PropsWithChildren, ReactNode } from "react";

const TITLE_MARGIN = 6;

type Props = PropsWithChildren<{
  title?: string;
  subTitle?: ReactNode;
  withDivider?: boolean;
  submitButtonLabel?: string;
  submitButtonDescription?: ReactNode; // TODO Nice to have, refactor as submitButtonConfig?: {label:string, description?: ReactNode, onClick....}
  submitDisabled?: boolean;
  onSubmitClick?: () => void;
  isSubmitting?: boolean;
  /** Smaller text button under the primary one (e.g. a skip action). */
  secondaryButtonLabel?: string;
  onSecondaryButtonClick?: () => void;
  secondaryButtonDisabled?: boolean;
}>;

export const StepBox = ({
  title,
  subTitle,
  children,
  withDivider,
  submitButtonLabel,
  submitButtonDescription,
  submitDisabled,
  onSubmitClick,
  isSubmitting,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  secondaryButtonDisabled,
}: Props) => {
  const mb = withDivider ? 0 : TITLE_MARGIN;

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      justifyContent="space-between"
    >
      <Box height="100%">
        {!!title && (
          <Typography mb={mb} mt={2}>
            {title}
          </Typography>
        )}
        {!!subTitle && <Box mb={mb}>{subTitle}</Box>}
        {withDivider && <Divider sx={{ my: TITLE_MARGIN }} />}
        {children}
      </Box>
      {!!(submitButtonLabel || secondaryButtonLabel) && (
        <Box>
          {submitButtonDescription}
          {!!submitButtonLabel && (
            <PrimaryButton
              color="primary"
              fullWidth
              sx={{ marginTop: 3 }}
              type={onSubmitClick ? "button" : "submit"}
              onClick={onSubmitClick}
              disabled={submitDisabled}
              isLoading={isSubmitting}
            >
              {submitButtonLabel}
            </PrimaryButton>
          )}
          {!!secondaryButtonLabel && (
            <Button
              variant="text"
              color="primary"
              size="small"
              fullWidth
              sx={{ marginTop: 1 }}
              onClick={onSecondaryButtonClick}
              disabled={secondaryButtonDisabled}
            >
              {secondaryButtonLabel}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};
